<template>
  <q-expansion-item
    v-model="expansionOpen"
    :header-class="headerClasses"
    :class="{'q-pb-lg': expansionOpen, 'without-border': withoutBorder}"
    class="form-group"
  >
    <template #header>
      <q-item-section>
        <q-item-label
          v-if="form.update_available"
          class="text-orange-10 text-uppercase text-weight-bold"
          caption
          style="letter-spacing: 1px;"
        >
          Update Available
        </q-item-label>
        <q-item-label class="module-name">
          {{ form.title }}
        </q-item-label>
        <q-item-label caption>
          <span v-if="form.standard" class="q-pr-md">
            {{ form.standard }}
          </span>
          {{ form.revisions.length }} {{ pluraliseString('revision', form.revisions.length) }}
        </q-item-label>
      </q-item-section>
    </template>

    <q-separator />

    <q-list
      padding
      separator
    >
      <FormRevision
        v-for="(revision, key) in form.revisions"
        :key="key"
        :revision="revision"
        :selected="revision.id === selected"
        :without-timestamp="withoutTimestamp"
        :with-title="form.title !== revision.title"
        @click="$emit('formClick', revision)"
      />
    </q-list>
  </q-expansion-item>
</template>

<script>
import FormRevision from './Revision'

export default {
  components: {
    FormRevision
  },
  props: {
    form: {
      type: Object,
      required: true
    },
    // ID of selected form
    selected: {
      type: Number,
      default: null
    },
    withoutBorder: {
      type: Boolean,
      default: false
    },
    // Hide revision date
    withoutTimestamp: {
      type: Boolean,
      default: false
    }
  },
  emits: ['formClick'],
  data () {
    return {
      expansionOpen: false
    }
  },
  computed: {
    headerClasses () {
      return {
        'form-group-header module-item': true,
        'update-available': this.form.update_available,
        'contains-draft': this.form.contains_draft,
        'bg-grey-2': this.expansionOpen
      }
    }
  }
}
</script>
